export const API_DOCS_LINK = "https://getsales-public-api.redocly.app/";
